export const modifySize = (fontString, modifyFrac) => {
  const fontNumber = parseFloat(fontString)
  const fontUnit = fontString.replace(/[0-9]/g, '')
  return `${fontNumber * modifyFrac}${fontUnit}`
}
export const heading = ({ theme }, size, color?) => {
  const setColor = color ? color : theme['theme-title']

  return `
      text-align: center;
      font-size: ${size};
      font-weight: bold;
      color: ${setColor};
      @media ${theme.mobile} {
          font-size: ${modifySize(size, 1 / 1.5)};
      }
      @media ${theme.tablet} {
          font-size: ${modifySize(size, 1 / 1.5)};
      }
  `
}
